const config = {
  apiGateway: {
    REGION: 'eu-west-1',
    INTERNAL_API_URL: 'https://c2zya1bteg.execute-api.eu-west-1.amazonaws.com/prod',
    TEAM_API_URL: 'https://5nbed4qdu0.execute-api.eu-west-1.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.eu.forwood.one'
  },
  configurationService: {
    URL: 'https://config.eu.forwood.one',
    WEBSOCKET: 'wss://njlct11lni.execute-api.eu-west-1.amazonaws.com/prod'
  },
};

export default config;
